<template>
  <div>
    <hr class="my-8 border-gray-very-light" />
    <h2 class="text-base mb-8">{{ $t('formation.courses.eventsSerie') }}</h2>
    <Labels v-if="serieName" label-type="blue" :items="serieName" />
    <div class="border-4 border-blue rounded mt-1">
      <div
        v-for="serie in series"
        :key="serie.slug"
        class="bg-blue-very-light px-1 py-2 last:pb-1 first:pt-1"
      >
        <SerieCard class="pb-3 last:pb-0" :serie="serie" />
      </div>
    </div>
  </div>
</template>

<script>
import Labels from '~/components/Labels';
import SerieCard from '~/components/Cards/Course/Serie';
export default {
  name: 'PrSerieEvents',
  components: {
    Labels,
    SerieCard
  },
  props: {
    serieName: {
      type: String,
      default: ''
    },
    series: {
      type: Array,
      default: () => []
    }
  }
};
</script>
